var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.enableBidIdParsing
      ? _c("div", { staticClass: "form-group m-b-15" }, [
          _c("label", { staticClass: "control-label col-md-3 col-sm-3" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("PING_TREE_TARGET_BID_ID_PARSING")) +
                "\n      "
            ),
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.right",
                  value: _vm.$t("PING_TREE_TARGET_BID_ID_PARSING_TT"),
                  expression: "$t('PING_TREE_TARGET_BID_ID_PARSING_TT')",
                  modifiers: { right: true }
                }
              ],
              staticClass: "fa fa-question-circle m-l-5"
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "display-flex m-b-10 col-md-9" },
            [
              _c("SearchableDropdown", {
                staticClass: "m-r-15 m-b-10 input--size-md",
                attrs: {
                  config: _vm.selectablePropertiesConfig,
                  clearable: false,
                  rules: "required",
                  name: "bidIdParsingSettings"
                },
                on: { change: _vm.updateBidIdParsingSettings },
                model: {
                  value: _vm.bidIdParsing[0].property,
                  callback: function($$v) {
                    _vm.$set(_vm.bidIdParsing[0], "property", $$v)
                  },
                  expression: "bidIdParsing[0].property"
                }
              }),
              _vm._v(" "),
              _c("label", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "REQUIRED",
                    expression: "'REQUIRED'"
                  }
                ],
                staticClass: "form-group__label-required"
              })
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }